module.exports = __webpack_public_path__ + "img/pwrrail_d.a476ebe2.svg";